import { MapfreButtonComponent } from '../../../_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreCardComponent } from '../../../_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { AcmicService } from '../../../_services/acmic.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule, MapfreCardComponent, MapfreButtonComponent],
  selector: 'error-error-content',
  templateUrl: './error-content.component.html',
})
export class ErrorContentComponent implements OnInit {
  @Input() image:   string;
  @Input() errorType:   string;
  @Input() copy:    string;
  isAcmic: boolean;

  constructor(private acmicService: AcmicService) { }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
  }

}
